export const STORAGE_KEYS = {
    TASKS: 'tasks',
    THEME: 'dc_keep_sticky_notes_settings'
};

export const THEME = {
    LIGHT: 'light',
    DARK: 'dark'
};

export const NOTE_COLORS = [
    'note-color-1',
    'note-color-2',
    'note-color-3',
    'note-color-4',
    'note-color-5',
    'note-color-6',
    'note-color-7',
    'note-color-8',
    'note-color-9',
    'note-color-10',
    'note-color-11'
];

export const DEFAULT_NOTE_COLOR = 'note-color-1';

export const MODAL_MODE = {
    ADD: 'add',
    EDIT: 'edit'
};

export const BREAKPOINTS = {
    MOBILE: 480,
    TABLET: 768,
    DESKTOP: 992,
    WIDE: 1200
};
